/* 30 Oct 2026: /products/digital-postcards?artist=moronobu opens the picker on that artist.
   Used by the "digital postcards" offer on an artist room that has no printed pieces yet.
   It only presses the artist's own filter chip once the picker has drawn them, so the picker itself is untouched. */
(function () {
  "use strict";
  var qa;
  try { qa = new URLSearchParams(location.search).get("artist"); } catch (e) { return; }
  if (!qa || !/^[a-z0-9-]+$/i.test(qa)) return;
  function go() {
    var root = document.getElementById("jm-pc");
    if (!root) return;
    var mo = null;
    function press() {
      var chips = root.querySelectorAll('[data-chips] [data-artist="' + qa + '"]');
      if (!chips.length) return false;
      if (mo) mo.disconnect();
      for (var i = 0; i < chips.length; i++) chips[i].click();
      return true;
    }
    // The picker may have drawn its chips already, or it may still be fetching the catalogue.
    if (press()) return;
    mo = new MutationObserver(press);
    mo.observe(root, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", go); else go();
})();
